"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const ColonyName_1 = require("@/common/colonies/ColonyName");
const utils_1 = require("@/common/utils/utils");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'ColonyTradeRow',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ColonyName() {
            return ColonyName_1.ColonyName;
        },
    },
    methods: {
        range(n) {
            return (0, utils_1.range)(n);
        },
    },
});
